module.exports = __webpack_public_path__ + "img/Icon_Certificación_Child_Count_Hover.91411ff3.svg";